const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(window.location.hostname)
);

type Config = {
  onSuccess?: (r: ServiceWorkerRegistration) => void;
  onUpdate?: (r: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() =>
          console.log('[PWA] Served cache-first by service worker')
        );
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker.register(swUrl).then((registration) => {
    // 上次已下載但尚未啟用的新版
    if (registration.waiting && navigator.serviceWorker.controller) config?.onUpdate?.(registration);
    // 分頁長時間開著也要能收到新版：切回分頁時與每 30 分鐘檢查一次
    const check = () => registration.update().catch(() => {});
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
    setInterval(check, 30 * 60 * 1000);
    registration.onupdatefound = () => {
      const w = registration.installing;
      if (!w) return;
      w.onstatechange = () => {
        if (w.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            config?.onUpdate?.(registration);
          } else {
            config?.onSuccess?.(registration);
          }
        }
      };
    };
  }).catch((err) => console.error('[PWA] SW registration error:', err));
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } }).then((res) => {
    const ct = res.headers.get('content-type');
    if (res.status === 404 || (ct != null && !ct.includes('javascript'))) {
      navigator.serviceWorker.ready.then((r) => r.unregister().then(() => window.location.reload()));
    } else {
      registerValidSW(swUrl, config);
    }
  }).catch(() => console.log('[PWA] No internet — running offline'));
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((r) => r.unregister())
      .catch((err) => console.error(err.message));
  }
}
